export enum USER_LEVEL {
  TENANT_LEVEL = 1,
  PO_LEVEL = 2,
}
